"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveFileNotificationT = exports.SaveFileNotification = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Used for the server to save a file and have it prompt in the user side
 */
class SaveFileNotification {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSaveFileNotification(bb, obj) {
        return (obj || new SaveFileNotification()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSaveFileNotification(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SaveFileNotification()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * Binary data of the file
     */
    data(index) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    dataLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    dataArray() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    mimeType(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    fileExtension(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    /**
     * Directory recommended to save the file on
     */
    expectedDir() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : null;
    }
    expectedFilename(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startSaveFileNotification(builder) {
        builder.startObject(5);
    }
    static addData(builder, dataOffset) {
        builder.addFieldOffset(0, dataOffset, 0);
    }
    static createDataVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startDataVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addMimeType(builder, mimeTypeOffset) {
        builder.addFieldOffset(1, mimeTypeOffset, 0);
    }
    static addFileExtension(builder, fileExtensionOffset) {
        builder.addFieldOffset(2, fileExtensionOffset, 0);
    }
    static addExpectedDir(builder, expectedDir) {
        builder.addFieldInt8(3, expectedDir, 0);
    }
    static addExpectedFilename(builder, expectedFilenameOffset) {
        builder.addFieldOffset(4, expectedFilenameOffset, 0);
    }
    static endSaveFileNotification(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSaveFileNotification(builder, dataOffset, mimeTypeOffset, fileExtensionOffset, expectedDir, expectedFilenameOffset) {
        SaveFileNotification.startSaveFileNotification(builder);
        SaveFileNotification.addData(builder, dataOffset);
        SaveFileNotification.addMimeType(builder, mimeTypeOffset);
        SaveFileNotification.addFileExtension(builder, fileExtensionOffset);
        if (expectedDir !== null)
            SaveFileNotification.addExpectedDir(builder, expectedDir);
        SaveFileNotification.addExpectedFilename(builder, expectedFilenameOffset);
        return SaveFileNotification.endSaveFileNotification(builder);
    }
    unpack() {
        return new SaveFileNotificationT(this.bb.createScalarList(this.data.bind(this), this.dataLength()), this.mimeType(), this.fileExtension(), this.expectedDir(), this.expectedFilename());
    }
    unpackTo(_o) {
        _o.data = this.bb.createScalarList(this.data.bind(this), this.dataLength());
        _o.mimeType = this.mimeType();
        _o.fileExtension = this.fileExtension();
        _o.expectedDir = this.expectedDir();
        _o.expectedFilename = this.expectedFilename();
    }
}
exports.SaveFileNotification = SaveFileNotification;
class SaveFileNotificationT {
    constructor(data = [], mimeType = null, fileExtension = null, expectedDir = null, expectedFilename = null) {
        this.data = data;
        this.mimeType = mimeType;
        this.fileExtension = fileExtension;
        this.expectedDir = expectedDir;
        this.expectedFilename = expectedFilename;
    }
    pack(builder) {
        const data = SaveFileNotification.createDataVector(builder, this.data);
        const mimeType = (this.mimeType !== null ? builder.createString(this.mimeType) : 0);
        const fileExtension = (this.fileExtension !== null ? builder.createString(this.fileExtension) : 0);
        const expectedFilename = (this.expectedFilename !== null ? builder.createString(this.expectedFilename) : 0);
        return SaveFileNotification.createSaveFileNotification(builder, data, mimeType, fileExtension, this.expectedDir, expectedFilename);
    }
}
exports.SaveFileNotificationT = SaveFileNotificationT;
